import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';

import { LinkedCatalogue } from './useLinkedCatalogues';

/** Formate un tarif (chaîne renvoyée par l'API) en euros, ou le renvoie tel quel. */
const formatTarif = (tarif?: string | null): string | undefined => {
    if (tarif === null || tarif === undefined || tarif === '') {
        return undefined;
    }
    const amount = Number(tarif);
    if (Number.isNaN(amount)) {
        return String(tarif);
    }
    return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
};

/**
 * Ligne d'une surcharge d'article posée au niveau du catalogue : libellé de
 * l'article et valeurs surchargées (libellé, tarif, quantité).
 */
const CatalogueSurchargeLine: React.FunctionComponent<{
    surcharge: NonNullable<LinkedCatalogue['surchargeArticles']>[number];
}> = function ({ surcharge }) {
    const articleLabel =
        surcharge.relationArticle?.libelle ??
        surcharge.relationArticle?.article?.libelle ??
        'Article';

    const overriddenTarif = formatTarif(surcharge.tarif);
    const originalTarif = formatTarif(surcharge.relationArticle?.tarif);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: '25px',
                py: 0.5,
            }}
        >
            <Typography
                variant="l2dbodyxs"
                color="text.gris70"
            >
                {surcharge.libelle ?? articleLabel}
            </Typography>
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
            >
                {surcharge.quantite != null ? (
                    <Chip
                        size="small"
                        variant="outlined"
                        label={`Qté : ${surcharge.quantite}`}
                    />
                ) : null}
                {overriddenTarif ? (
                    <Chip
                        size="small"
                        color="primary"
                        label={
                            originalTarif && originalTarif !== overriddenTarif
                                ? `${originalTarif} → ${overriddenTarif}`
                                : overriddenTarif
                        }
                    />
                ) : null}
            </Stack>
        </Box>
    );
};

export default CatalogueSurchargeLine;
